var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"my-1 d-inline-block",class:{ error: Number(_vm.limit) < _vm.text.length }},[_vm._v(" "+_vm._s(_vm.text.length)+" / "+_vm._s(_vm.limit)+" "),(_vm.minimum)?_c('span',{staticClass:"min"},[_vm._v(" щонайменше "+_vm._s(_vm.minimum))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }